import React, { useEffect, useState } from 'react';
import WpAPI from '../WpApi';

/**
 * PaywallGate (Site Shutdown Gate)
 *
 * When the server signals that the site is shutting down
 * (`paywall_active: true` from GET /wp-json/ro/v1/transition-status),
 * ALL users are redirected to the new site URL returned by the API.
 *
 * If no new_site_url is set yet, the gate does nothing so users can
 * still access the site normally until the URL is configured.
 *
 * The login and download paths are always allowed through so users
 * can log in and download their resumes right up to the deadline.
 */
const ALWAYS_ALLOWED_PATHS = [
    '/login/',
    '/logout/',
    '/forget-password/',
    '/forgot-password/',
    '/reset-password/',
];

const isAllowedPath = (pathname) =>
    ALWAYS_ALLOWED_PATHS.some((p) => pathname.startsWith(p));

const PaywallGate = ({ children }) => {
    const [checked, setChecked] = useState(false);
    const [shutdownActive, setShutdownActive] = useState(false);
    const [newSiteUrl, setNewSiteUrl] = useState('');

    useEffect(() => {
        WpAPI.getTransitionStatus().then((status) => {
            setShutdownActive(!!status.paywall_active);
            setNewSiteUrl(status.new_site_url || '');
            setChecked(true);
        });
    }, []);

    // Don't block rendering while the status is being fetched
    if (!checked) return <>{children}</>;

    const currentPath = window.location.pathname;

    // When shutdown is active and a new site URL is configured, redirect everyone
    // except those on the allowed paths (login/download still work until deadline).
    if (shutdownActive && newSiteUrl && !isAllowedPath(currentPath)) {
        window.location.replace(newSiteUrl);
        return null;
    }

    return <>{children}</>;
};

export default PaywallGate;
